import React from 'react';

import { NamedLink } from '../../components';
import config from '../../config';

import Tent from './quechua_tent.png';
import Surfboard from './newSup.png';
import Bike from './triban.png';
import Fitness from './fitness.avif';
import Treadmill from './bikes_treadmill.png';
import BikesElectric from './elect_bike.webp';
import Snowboard from './snowboard_pic.webp';
import SurfboardCZ from './sup.png';
import BikeCZ from './gravel.png';
import Carrier from './carrier.png';
import Ski from './ski.avif';
import SkiCross from './skicross.png';
import HuPromo from './huRules.png';

import css from './LandingPage.css';

const countryConfiguration = [
  {
    countryId: 'pl',
    firstImg: Surfboard,
    firstRedirection: 'businessCategory=watersports_sup&exact=true',
    secondImg: Bike,
    secondRedirection: 'keywords=rower',
    thirdImg: Tent,
    thirdRedirection: 'businessCategory=camping_tent&exact=true',
  },
  {
    countryId: 'cz',
    firstImg: Ski,
    firstRedirection: 'businessCategory=wintersports_alpineskiing&category=wintersports&exact=true',
    secondImg: Fitness,
    secondRedirection: 'businessCategory=fitness_cardio&category=fitness&exact=true',
    thirdImg: SkiCross,
    thirdRedirection: 'businessCategory=wintersports_crosscountry&category=wintersports&exact=true',
  },
  {
    countryId: 'sk',
    firstImg: Tent,
    firstRedirection: 'businessCategory=camping_tent&exact=true',
    secondImg: Surfboard,
    secondRedirection: 'businessCategory=watersports_sup&category=watersports&exact=true',
    thirdImg: Bike,
    thirdRedirection: 'keywords=bicykel',
  },
  {
    countryId: 'hu',
    firstImg: Tent,
    firstRedirection: 'businessCategory=camping_tent&exact=true',
    secondRedirection: 'businessCategory=bikes_electric&exact=true',
    secondImg: BikesElectric,
    thirdImg: Ski,
    thirdRedirection: 'businessCategory=wintersports_alpineskiing&exact=true',
  }
];

const countryId = config.custom.countryId;
const defaultConfig = countryConfiguration.find(item => item.countryId === 'pl');
const countryConfig = countryConfiguration.find(item => item.countryId === countryId);

const SectionPopularCategories = props => {
  const { intl } = props;
  const configuration = {};

  Object.keys(defaultConfig).forEach(key => {
    const value = countryConfig?.hasOwnProperty(key) ? countryConfig[key] : defaultConfig[key];
    configuration[key] = value;
  })

  const categoriesData = [
    {
      img: configuration.firstImg,
      name: intl.formatMessage({ id: 'LandingPage.popularCategories.cat1' }),
      to: configuration.firstRedirection,
    },
    {
      img: configuration.secondImg,
      name: intl.formatMessage({ id: 'LandingPage.popularCategories.cat2' }),
      to: configuration.secondRedirection,
    },
    {
      img: configuration.thirdImg,
      name: intl.formatMessage({ id: 'LandingPage.popularCategories.cat3' }),
      to: configuration.thirdRedirection,
      externalTo: configuration.thirdExternalLink
    },
  ];

  return (
    <div className={css.popularCategories}>
      {categoriesData.map(({ img, name, category, to, externalTo }, key) => {
        if (externalTo) return (
          <a href={externalTo} className={css[`category-${key + 1}`]}>
            <div>
              <p>{name}</p>
            </div>
            <img src={img} alt={name} />
          </a>
        )
        return <NamedLink
          name="SearchPage"
          to={{
            search: to,
          }}
          key={key}
          className={css[`category-${key + 1}`]}
        >
          <div>
            <p>{name}</p>
          </div>
          <img src={img} alt={name} />
        </NamedLink>
      })}
    </div>
  );
};

export default SectionPopularCategories;
